import {
  CALL_RESET,
  CALL_SET_CONSULT,
  CALL_SET,
  UPDATE_CALL,
  UPDATE_CALL_TRANSFER_ENDPOINTS,
  RESET_NORMAL_CALL,
  HISTORY_FILTER_CALL_COUNT,
  DIAL_CALL_IN_PROGRESS,
} from "../constants/action-types";

export function callReset(lastCall = null) {
  return {
    type: CALL_RESET,
    lastCall,
  };
}

export function setConsultCall(consultCall: any) {
  return {
    type: CALL_SET_CONSULT,
    consultCall,
  };
}

export function setCallState(call: any) {
  return {
    type: CALL_SET,
    call,
  };
}
export function updateNormalCall(call: any) {
  return {
    type: UPDATE_CALL,
    call,
  };
}
export function updateTransferEndpoints(call: any) {
  return {
    type: UPDATE_CALL_TRANSFER_ENDPOINTS,
    call,
  };
}

export function resetNormalCall() {
  return {
    type: RESET_NORMAL_CALL,
  };
}

export function setHistoryfilterCallCount(callCount: number) {
  return {
    type: HISTORY_FILTER_CALL_COUNT,
    callCount,
  };
}

export const SET_DIAL_NUMBER = "SET_DIAL_NUMBER";

export function setDialNumber(phoneNumber: string) {
  return {
    type: SET_DIAL_NUMBER,
    payload: phoneNumber,
  };
}

export function isDialCallInProgress(dialCallInProgress: boolean) {
  return {
    type: DIAL_CALL_IN_PROGRESS,
    dialCallInProgress,
  };
}

// Conference actions
export const setConference = (payload: any) => ({
  type: "CONFERENCE_SET",
  payload: payload,
});

export const updateConference = (payload: any) => ({
  type: "CONFERENCE_UPDATE",
  payload: payload,
});

export const resetConference = () => ({ type: "CONFERENCE_RESET" });

export function setConsultConference(consultCall: any) {
  return {
    type: "CONFERENCE_SET_CONSULT",
    consultCall: consultCall,
  };
}

export function updateConferenceTransferEndpoints(conference: any) {
  return {
    type: "UPDATE_CONFERENCE_TRANSFER_ENDPOINTS",
    conference,
  };
}

export function isDialConferenceInProgress(dialCallInProgress: boolean) {
  return {
    type: "DIAL_CONFERENCE_IN_PROGRESS",
    dialCallInProgress,
  };
}

export function setHistoryfilterConferenceCount(callCount: number) {
  return {
    type: "HISTORY_FILTER_CONFERENCE_COUNT",
    callCount,
  };
}
